// Initialize react-scan only on client side
if (typeof window !== 'undefined' && (import.meta.env.VITE_MODE === 'development' || import.meta.env.VITE_MODE === 'staging' || import.meta.env.VITE_MODE === 'staging-local')) {
  import('react-scan').then(({ scan }) => {
    scan({ enabled: true });
  });
}

import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
//import reportWebVitals from './reportWebVitals';

const rootElement = document.getElementById('root');
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <App />
    </StrictMode>
);
} else {
  console.error("Root element with id 'root' not found.");
}

// reportWebVitals();
